<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-support-sidebar>
  <app-crud-table body #crudTable [crudService]="crudService"
                  [transPartKey]="transPartKey" [fieldId]="fieldId" [fieldName]="fieldId"
                  [tableConfig]="tableConfig" [newRecord]="newRecord"
                  [(formRecord)]="formRecord" [formConfig]="formConfig"
                  [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                  (dialogFormVisibleChange)="$event?onFormShow():{}"
                  [formLoading]="formLoading"
                  [writeRoles]="writeRoles" [totalRecords]="totalRecords"
                  [tableLoading]="tableLoading"
                  [(dialogFormVisible)]="dialogFormVisible"
                  [(selectedRecords)]="selectedRecords" [dialogFormTitle]="dialogFormTitle"
                  [contextMenuConfig]="contextMenuConfig" [headerButtonConfig]="headerButtonConfig"
                  [(tableCurrentRequest)]="tableCurrentRequest" [(records)]="records" (onSave)="onSaved()"
                  (onContextMenuShow)="refreshContextMenu()"
                  [globalErrorMessage]="globalErrorMessage"
                  [globalInfoMessage]="globalInfoMessage"
                  [prepareForEdit]="prepareRecordForEdit"
                  [beforeSave]="prepareRecordForSave"
  >
      <span table-toolbar-center>{{
          (tableCurrentRequest.syncMetadata ?
            (('common.lastUpdated'|translate) + ': ' +
              (tableCurrentRequest.syncMetadata.lastChange|date:'HH:mm:ss')) : '')
        }}</span>
  </app-crud-table>
</app-support-sidebar>
<app-batch-action-support-clearing-form [(dialogFormVisible)]="batchUpdateDialogVisible"
                                        [formRecord]="formRecord"
                                        [selectedRecords]="selectedRecords"
                                        [dataLoadingService]="dataLoadingService"
                                        [transPartKey]="transPartKey"
                                        (onSavedForm)="onBatchSaved()"
                                        [tracker]="tracker"
                                        [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
></app-batch-action-support-clearing-form>
